import { Select } from "../../components/Select.js"
import styles from "./SortBar.module.css"
import type { SortKey, SortOrder } from "./useBenefits.js"

const SORT_OPTIONS: { sort: SortKey; order: SortOrder; label: string }[] = [
  { sort: "code", order: "asc", label: "証券コード順" },
  { sort: "benefitValue", order: "asc", label: "優待金額 (低い順)" },
  { sort: "benefitValue", order: "desc", label: "優待金額 (高い順)" },
  { sort: "combinedYield", order: "desc", label: "総合利回り (高い順)" },
  { sort: "combinedYield", order: "asc", label: "総合利回り (低い順)" },
]

interface Props {
  total: number
  totalAll: number
  sort: SortKey
  order: SortOrder
  onChange: (sort: SortKey, order: SortOrder) => void
}

export function SortBar({ total, totalAll, sort, order, onChange }: Props) {
  const selectedValue = `${sort}-${order}`

  return (
    <div className={styles.bar}>
      <span className={styles.count}>
        {total.toLocaleString()}件
        {total !== totalAll && (
          <span className={styles.totalAll}> / 全{totalAll.toLocaleString()}件</span>
        )}
      </span>
      <Select
        ariaLabel="並び替え"
        value={selectedValue}
        options={SORT_OPTIONS.map(({ sort: s, order: o, label }) => ({
          value: `${s}-${o}`,
          label,
        }))}
        onChange={(v) => {
          const [s, o] = v.split("-") as [SortKey, SortOrder]
          onChange(s, o)
        }}
      />
    </div>
  )
}
